module.exports = __webpack_public_path__ + "static/2m-b42e8048642abea26cd1765f72b1a6e3.jpg";